export default __webpack_public_path__ + "static/media/Shoes10.423513ca.png";